import { Action } from '@interstate/components/Action';
import { Alert } from '@interstate/components/Alert';
import { LEASE_PAYMENT_GRID_PROGRAM_DISCLAIMER } from '@makemydeal/dr-dash-components';

import {
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_BODY,
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_LINK,
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_SUFFIX,
    GENERIC_LAST_FIELD_CHANGED_ERROR
} from '../../../constants';
import { useSummaryBanners } from '../../baseDealActivity/baseDealContainer/hooks/useSummaryBanners';
import { useAutoSelectedLenderProgramBanner } from '../../useAutoSelectedLenderProgramBanner';
import { BannersRoot } from './ScenarioBanners.style';

export const ACCESSORY_PRICES_ADJUSTED_TEXT =
    'We adjusted some accessory prices. Negative values were changed to $0.00 so payments can be calculated correctly.';

export const ScenarioBanners = () => {
    const { showsLeasePaymentGridDisclaimer, showsPaymentGridError, showsAccessoryPricesAdjusted, showsAutoSelectedLenderProgram } =
        useSummaryBanners();
    const { isAutoSelected, openProgramsAndIncentives } = useAutoSelectedLenderProgramBanner();
    const showsAutoSelectedBanner = showsAutoSelectedLenderProgram && isAutoSelected;

    if (!showsPaymentGridError && !showsLeasePaymentGridDisclaimer && !showsAccessoryPricesAdjusted && !showsAutoSelectedBanner) {
        return null;
    }

    return (
        <BannersRoot data-testid="scenario-banners">
            {showsPaymentGridError && (
                <Alert role="banner" type="error" data-testid="scenario-banner-payment-grid-error">
                    {GENERIC_LAST_FIELD_CHANGED_ERROR}
                </Alert>
            )}
            {showsLeasePaymentGridDisclaimer && (
                <Alert role="banner" type="info" data-testid="scenario-banner-lease-payment-grid-disclaimer">
                    {LEASE_PAYMENT_GRID_PROGRAM_DISCLAIMER}
                </Alert>
            )}
            {showsAccessoryPricesAdjusted && (
                <Alert role="banner" type="info" data-testid="scenario-banner-accessory-prices-adjusted">
                    {ACCESSORY_PRICES_ADJUSTED_TEXT}
                </Alert>
            )}
            {showsAutoSelectedBanner && (
                <Alert role="banner" type="info" data-testid="scenario-banner-auto-selected-lender-program">
                    {AUTO_SELECTED_LENDER_PROGRAM_BANNER_BODY}
                    <Action size="sm" onClick={openProgramsAndIncentives}>
                        {AUTO_SELECTED_LENDER_PROGRAM_BANNER_LINK}
                    </Action>
                    {AUTO_SELECTED_LENDER_PROGRAM_BANNER_SUFFIX}
                </Alert>
            )}
        </BannersRoot>
    );
};
